// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operators{
    width: 100%;
    height: 100%;
    align-content: center;
}

.operators__header{
    font-size: 4rem;
    font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/operator/operators-main/OperatorsMain.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":[".operators{\r\n    width: 100%;\r\n    height: 100%;\r\n    align-content: center;\r\n}\r\n\r\n.operators__header{\r\n    font-size: 4rem;\r\n    font-weight: 600;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
